"use client";

import React from "react";
import { openPrivacyChoices } from "@/stores/privacyChoicesStore";

export interface PrivacyChoicesTriggerProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onClick"> {
  children: React.ReactNode;
}

/**
 * Inline button styled to match a footer text-link. Clicking opens the
 * "Your Privacy Choices" modal via the shared Valtio store.
 *
 * Hardcoded into the footer's legal-links row (next to Privacy Policy
 * and Terms of Service) — see `src/components/footer/Footer.tsx`.
 *
 * The inline `style` block ONLY resets native `<button>` chrome that
 * would visually diverge from a sibling `<a>` (background, border,
 * padding, margin, cursor). It deliberately does NOT override `color`,
 * `font`, or `text-align` — those need to flow through from the
 * `className` props (e.g. `body-sm` + `Footer.module.css .legalLink`)
 * so the trigger matches sibling links exactly, including the
 * footer-foreground 70% color-mix tint.
 */
export function PrivacyChoicesTrigger({
  children,
  className,
  type = "button",
  ...rest
}: PrivacyChoicesTriggerProps) {
  return (
    <button
      type={type}
      className={className}
      onClick={openPrivacyChoices}
      style={{
        background: "transparent",
        border: 0,
        padding: 0,
        margin: 0,
        cursor: "pointer",
      }}
      {...rest}
    >
      {children}
    </button>
  );
}

export default PrivacyChoicesTrigger;
